module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pleaseWait":"Please wait...","open":"Filter"},"de":{"pleaseWait":"Bitte warten...","open":"Filter öffnen"}}')
  delete Component.options._Ctor
}
